"use client"; 
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Governance Made Simple",
    "Data You Can Trust",
    "Secure by Design",
    "Compliance, Without Compromise",
    "360° Visibility",
   
  ];

  const tabContent = [
    {
      heading: "Governance Made Simple",
      subheading: "We simplify complex data governance frameworks, ensuring seamless compliance without overwhelming your operations.",
      image: cl1Tab, 
    },
    {
      heading: "Data You Can Trust",
      subheading: " Our solutions emphasize data accuracy, consistency, and reliability,transforming your data into a trusted asset for decision-making. ",
      image: cl2Tab,
    },
    {
      heading: "Secure by Design",
      subheading: " With a focus on robust security measures, we safeguard your data assets against threats while maintaining accessibility for authorized users.",
      image: cl3Tab,
    },
    {
      heading: "Compliance, Without Compromise",
      subheading: "We ensure that your data meets all regulatory and industry standards, keeping your business compliant and risk-free.",
      image: cl4Tab,
    },
    {
      heading: "360° Visibility",
      subheading: " Our governance frameworks provide comprehensive insights into your data’s lifecycle, empowering you to monitor, manage, and optimize your data ecosystem effectively.",
      image: cl4Tab,
    },
   
  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}
            
          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${
            index === activeTab ? "active" : ""
          }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>
            
          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
            <Image
              src={tabContent[activeTab].image}
              alt={tabContent[activeTab].heading}
              width={457}
              height={257}
              className="productbanner_imageslider"
              loading="eager"
            />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
